module.exports = __webpack_public_path__ + "img/JDRF_Royal_A.502c3b74.jpg";